<template>
  <div class="company-clients">
    <!-- client details -->
    <div class="company-clients-content">
      <div class="company-clients-content-header">
        <TText large value="CLIENT.details" />
      </div>
      <div class="company-clients-content-body">
        <DisableableInputField label="Name" :value="selected_procoreclient.name" background_color="#121212"
          @change="updateClient({ name: $event })" />
          <TText value="BASE.uri without trailing slash, e.g. https://sandbox.procore.com/rest" size="8" />
        <DisableableInputField label="BASE.uri" :value="selected_procoreclient.base_uri" background_color="#121212"
          @change="updateClient({ base_uri: $event })" />
        
          <!-- <DisableableInputField label="QUERY.string" :value="selected_procoreclient.query_string" background_color="#121212"
          @change="updateQueryString($event)" /> -->

        <DisableableInputField label="CLIENT.id" :value="selected_procoreclient.identifier" background_color="#121212"
          @change="updateClient({ identifier: $event })" />
        <ButtonOutlined @buttonClicked="copyToClipboard(selected_procoreclient.identifier)" style="width: 100%;" text_size="12"
          value="Copy CLIENT.id" />
        <DisableableInputField label="CLIENT.secret" :value="selected_procoreclient.secret" background_color="#121212" 
          @change="updateClient({ secret: $event })" />
        <ButtonOutlined @buttonClicked="copyToClipboard(selected_procoreclient.secret)" style="width: 100%;" text_size="12"
        value="Copy CLIENT.secret" />
        <DisableableInputField label="Procore Company Id" :value="selected_procoreclient.company_id" background_color="#121212" 
          @change="updateClient({ company_id: $event })" />
      </div>
      <ButtonOutlined v-if="is_client_create" class="mt-5" @buttonClicked="create()" style="width: 100%;" text_size="12" value="Create client" />
      <ButtonOutlined v-if="!is_client_create" class="mt-5" @buttonClicked="deleteClient()" style="width: 100%;" text_size="12" value="Delete client" />
      
      <!-- <ButtonOutlined class="mt-5" @buttonClicked="updateUObject({
        url: [
            { businesses: getBusiness.id },
            { procoreclients: client_id }
          ],
          url_suffix: '/testcall',
          update: { test: 'test' }
      })" style="width: 100%;" text_size="12" value="TEST API" /> -->

    </div>

    <!-- <div class="company-clients-seperator"></div> -->
  </div>
</template>

<script>
import { CompanyClientsMixin } from '@/mixins/CompanyClients.mixin.js'
import { mapActions } from 'vuex';

export default {
  name: 'CompanyClientsDetails',
  components: {
  },
  mixins: [CompanyClientsMixin],
  data: function () {
    return {
    }
  },
  created() {

  },
  computed: {

  },
  methods: {
    ...mapActions('Client', [
      'addClientToProjects',
      'removeClientFromProject',
      'setProcoreClientValue',
      'addClientToBusiness',
    ]),
    updateQueryString(query_string) {

      // if query_string is not empty and does not start with either ? or & add a ?
      if (query_string.length > 0 && !['?', '&'].includes(query_string[0])) {
        query_string = '?' + query_string;
      }
      this.updateClient({ query_string: query_string });
    },
    updateClient(update) {
      if (this.is_client_create) {
        this.setProcoreClientValue(update);
      } else {
        this.updateUObject({
          url: [
            { businesses: this.getBusiness.id },
            { procoreclients: this.client_id }
          ],
          update: update
        })
      }
    },
    copyToClipboard(msg) {
      navigator.clipboard.writeText(msg);
    },
    deleteClient(){
      this.deleteUObject({
          url: [
            { businesses: this.getBusiness.id },
            { procoreclients: this.client_id }
          ]
        }).then(() => {
          this.$router.push({ name: 'ProcoreClients' });
        })
    },
    create(){
      this.createUObject({
        url: [
          { businesses: this.getBusiness.id },
          { procoreclients: '' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: this.selected_procoreclient
      }).then(client_id => {
        this.$router.push({ name: 'ProcoreClientsDetails', params: { client_id: client_id} });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.company-clients {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  // padding: 5px;
}

.company-clients-content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.company-clients-seperator {
  background-color: #fff !important;
  border-color: #fff !important;
  // background-color: #000!important;
  // border-color: #000!important;
  position: relative;
  display: flex;
  flex-shrink: 0;
  height: calc(100% - 10px);
  top: 5px;
  width: 1px;
  opacity: .2;
}

.company-clients-content {
  display: flex;
  flex-direction: column;
  // background-color: blue;
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
}

.company-client-content-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 380px;
}

.company-clients-content-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  grid-gap: 10px;
  max-width: 400px !important;
}
</style>
